import * as React from 'react';
import { connect } from 'react-redux';
import { ButtonCheckbox } from '../../../../common/components/button_checkbox/index';
import { IAppState, Dispatch } from '../../../../common/state';
import { IJsonQuery } from '../../../../json_query';
import { getTermValue } from '../../../../json_query/reducers/helpers';
import { setTermValue } from '../../../state/advanced/term';
import { Row, InlineParam } from '../markup';

export interface IGarageTechincalCharacteristicsProps {
  hasElectricity: boolean;
  hasExtinguishingSystem: boolean;
  hasHeating: boolean;
  hasLight: boolean;
  hasWater: boolean;

  setTerm(key: keyof IJsonQuery, value: boolean): void;
}

class GarageTechincalCharacteristics extends React.PureComponent<IGarageTechincalCharacteristicsProps> {
  public render() {
    const { hasElectricity, hasExtinguishingSystem, hasHeating, hasLight, hasWater, setTerm } = this.props;

    return (
      <Row title="Технические характеристики">
        <InlineParam>
          <ButtonCheckbox value={hasLight} onValueChange={setTerm.bind(null, 'has_light', !hasLight)}>
            Свет
          </ButtonCheckbox>
        </InlineParam>
        <InlineParam>
          <ButtonCheckbox value={hasElectricity} onValueChange={setTerm.bind(null, 'has_electricity', !hasElectricity)}>
            Электричество
          </ButtonCheckbox>
        </InlineParam>
        <InlineParam>
          <ButtonCheckbox value={hasWater} onValueChange={setTerm.bind(null, 'has_water', !hasWater)}>
            Вода
          </ButtonCheckbox>
        </InlineParam>
        <InlineParam>
          <ButtonCheckbox value={hasHeating} onValueChange={setTerm.bind(null, 'has_heating', !hasHeating)}>
            Отопление
          </ButtonCheckbox>
        </InlineParam>
        <InlineParam>
          <ButtonCheckbox
            value={hasExtinguishingSystem}
            onValueChange={setTerm.bind(null, 'has_extinguishing_system', !hasExtinguishingSystem)}
          >
            Система пожаротушения
          </ButtonCheckbox>
        </InlineParam>
      </Row>
    );
  }
}

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => {
    const { jsonQuery } = state.filters;

    return {
      hasElectricity: Boolean(getTermValue('has_electricity')(jsonQuery)),
      hasExtinguishingSystem: Boolean(getTermValue('has_extinguishing_system')(jsonQuery)),
      hasHeating: Boolean(getTermValue('has_heating')(jsonQuery)),
      hasLight: Boolean(getTermValue('has_light')(jsonQuery)),
      hasWater: Boolean(getTermValue('has_water')(jsonQuery)),
    };
  },
  (dispatch: Dispatch) => ({
    setTerm: (key: keyof IJsonQuery, value: boolean) => {
      dispatch(setTermValue<boolean>(key, value || undefined));
    },
  }),
)(GarageTechincalCharacteristics);
